import { render, staticRenderFns } from "./RichTextField.vue?vue&type=template&id=6cc2c254&"
import script from "./RichTextField.vue?vue&type=script&lang=js&"
export * from "./RichTextField.vue?vue&type=script&lang=js&"
import style0 from "./RichTextField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports